import React, { useState, useCallback, useEffect } from "react";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";
import { URL } from "modules/utils/Common";

const PopupContext = React.createContext({
  state: { popupList: {}, popup: {} },
  actions: {
    getPopup: () => {},
    getPopupList: () => {},
  },
});

const PopupProvider = ({ children }) => {
  const [popup, setPopup] = useState({});
  const [popupList, setPopupList] = useState([]);
  
  const getPopupList = useCallback((pageInfo) => {
    HttpAction({
      url:"api/admin/popup/list", 
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        popupDisplayYn: pageInfo && pageInfo.popupDisplayYn,
        popupTypeCode: pageInfo && pageInfo.popupTypeCode,
        popupStartDate: pageInfo&& pageInfo.popupStartDate,
        popupEndDate: pageInfo&& pageInfo.popupEndDate,
        popupTitle: pageInfo&& pageInfo.popupTitle,
      }
    }).then((res) => {
      if (res.code === 200) {
        setPopupList(res.data);
      } else {
      }
    });
  }, []);

  const getPopup = useCallback((popupId) => {
    HttpAction({
      url:"api/admin/popup", 
      method: "get",
      params: {
        popupId: popupId
      }
    }).then((res) => {
      if (res.code === 200) {
        setPopup(res.data); 
      } else {
      }
    });
  }, []);

  const createPopup = useCallback((popupData,setState) => {
    HttpAction({
      url: "api/admin/popup/save",
      method: "post",
      data: {
        popupContent: popupData.popupContent,
        popupDisplayYn: popupData.popupDisplayYn,
        popupEndDate: popupData.popupEndDate,
        popupLinkUrl: popupData.popupLinkUrl,
        popupStartDate: popupData.popupStartDate,
        popupTitle: popupData.popupTitle,
        popupTypeCode: popupData.popupTypeCode 
      }
    }).then((res) => {
      if (res.code === 200) {
        setState({
          type: "SAVE",
          state: true,
        })
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const updatePopup = useCallback((popupData, setState) => {
    HttpAction({
      url: "api/admin/popup/modify",
      method: "post",
      data: {
        popupContent: popupData.popupContent,
        popupDisplayYn: popupData.popupDisplayYn,
        popupEndDate: popupData.popupEndDate,
        popupLinkUrl: popupData.popupLinkUrl,
        popupStartDate: popupData.popupStartDate,
        popupTitle: popupData.popupTitle,
        popupTypeCode: popupData.popupTypeCode,
        popupId: popupData.popupId,
      }
    }).then((res) => {
      if (res.code === 200) {
        setState({
          type: "SAVE",
          state: true,
        })
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const deletePopup = useCallback((popupId, history) => {
    HttpAction({
      url: "api/admin/popup",
      method: "delete",
      params: {
        popupId: popupId
      }
    }).then((res) => {
      if (res.code === 200) {
      history.push(`${URL.ADMIN_BASE_URL}/main/popup`)
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const value = {
    state: { popup, popupList },
    actions: { getPopupList, getPopup, createPopup, updatePopup, deletePopup },
  };

  return (
    <PopupContext.Provider value={value}>
      {children}
    </PopupContext.Provider>
  );
};

const { Consumer: PopupConsumer } = PopupContext;

export { PopupProvider, PopupConsumer, PopupContext };

export default PopupContext;
